import { PRIVATE_ADMIN_EXTRA_CONFIG, PRIVATE_ADMIN_EXTRA_CONFIG_FORM } from '../Constants/PathsConstant';
import ExtraTypeConfigListView from '../Views/ExtraTypeConfigListView';
import ExtraTypeConfigFormView from '../Views/ExtraTypeConfigFormView';
import PermissionRoute from 'Shared/Routing/Application/Routes/PermissionRoute';
import { EXTRAS_MANTENIMIENTO } from 'Shared/Security/Application/Constants/PermissionsConstant';

export const AfterSalesExtraRouter = [
  {
    path: PRIVATE_ADMIN_EXTRA_CONFIG,
    element: <PermissionRoute permission={EXTRAS_MANTENIMIENTO} />,
    children: [
      {
        index: true,
        element: <ExtraTypeConfigListView />
      }
    ]
  },
  {
    path: `${PRIVATE_ADMIN_EXTRA_CONFIG_FORM}/:id`,
    element: <PermissionRoute permission={EXTRAS_MANTENIMIENTO} />,
    children: [
      {
        index: true,
        element: <ExtraTypeConfigFormView />
      }
    ]
  },
  {
    path: PRIVATE_ADMIN_EXTRA_CONFIG_FORM,
    element: <PermissionRoute permission={EXTRAS_MANTENIMIENTO} />,
    children: [
      {
        index: true,
        element: <ExtraTypeConfigFormView />
      }
    ]
  }
];
